import { tr } from "@/lib/i18n";

/**
 * Shared inventory status → Tailwind class mapping for status pills.
 * Lives outside any single panel so ZoneHoverCard, UnitsList and
 * UnitDetail can all use the same source of truth.
 */
export function statusPill(s) {
  if (s === "available") return "bg-emerald-500/20 text-emerald-300 border border-emerald-500/30";
  if (s === "reserved") return "bg-amber-500/20 text-amber-300 border border-amber-500/30";
  if (s === "sold") return "bg-red-500/20 text-red-300 border border-red-500/30";
  return "bg-white/10 text-white/70";
}

/**
 * WhatsApp deep-link builder. Templated message lets the project owner
 * customise the lead message per-project; we only escape the unit code and
 * project name.
 */
export function waLink(project, unit, lang = "en") {
  const wa = project.contact_config?.whatsapp;
  if (!wa) return "#";
  const defaults = {
    en: unit ? "Hello, I am interested in {unit_code} at {project_name}." : "Hello, I am interested in {project_name}.",
    ar: unit ? "مرحبًا، أنا مهتم بالوحدة {unit_code} في {project_name}." : "مرحبًا، أنا مهتم بمشروع {project_name}.",
    tr: unit ? "Merhaba, {project_name} projesindeki {unit_code} ile ilgileniyorum." : "Merhaba, {project_name} projesiyle ilgileniyorum.",
    ru: unit ? "Здравствуйте! Меня интересует объект {unit_code} в проекте {project_name}." : "Здравствуйте! Меня интересует проект {project_name}.",
  };
  const tmpl = project.contact_config?.whatsapp_template || defaults[lang] || defaults.en;
  const name = tr(project, "name", lang, project.default_language) || project.name || "";
  const text = tmpl.replaceAll("{unit_code}", unit?.code || "").replaceAll("{project_name}", name);
  const phone = wa.replace(/[^0-9+]/g, "");
  return `https://wa.me/${phone.replace(/^\+/, "")}?text=${encodeURIComponent(text)}`;
}
